function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowClockwiseTimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.19 9.665l-1.104-3.15.944-.33 1.103 3.15a1 1 0 0 1-.145.932l-.881 1.17a1 1 0 0 1-.857.397l-3.332-.193.058-.998 3.332.192.164-.218A6.903 6.903 0 0 0 16 9a7 7 0 1 0 7 7h1a8 8 0 1 1-8-8c1.936 0 3.694.675 5.075 1.818l.115-.153zM15.293 16l-1.647-1.647.708-.707L16 15.293l1.646-1.647.708.707L16.707 16l1.647 1.646-.708.707L16 16.707l-1.646 1.646-.708-.707L15.293 16z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowClockwiseTimes);
export default __webpack_public_path__ + "static/media/arrow-clockwise-times.043189e38c2c86055e93c7640c0f945f.svg";
export { ForwardRef as ReactComponent };